export default __webpack_public_path__ + "1a831ecae37a14e88251f3e7b24e22c0.svg";